import { usePropertyStore } from "../../store/usePropertyStore";
import { useEffect, useState } from "react";
import { formatRupiah } from "../../utils/formatter";
import { useNavigate } from "react-router-dom";
import AuthEndpoint from "../../api/auth";
import { message } from "antd";
import { ReviewEnpoint, UserEndpoint } from "../../api";
import PropertyDetailInfo from "./detail-property";
import ReviewRating from "./propertydetails/reviewrating";

import { getBaseUrl } from "../../api/baseApi";

const BASE_URL = getBaseUrl();

const getImageUrls = (photo) => {
    if (!photo) return [];

    try {
        const parsed = JSON.parse(photo);

        // Jika hasil parse adalah array, tambahkan prefix BASE_URL ke semua
        if (Array.isArray(parsed)) {
            return parsed.map(item => BASE_URL + item);
        }
    } catch (err) {
        // Jika bukan array → anggap string single image
        return [BASE_URL + photo];
    }

    return [];
};


const ShopDetails = () => {
    const { detailProperti } = usePropertyStore();
    const [showLoginModal, setShowLoginModal] = useState(false);
    const [replyingTo, setReplyingTo] = useState(null);
    const [replyText, setReplyText] = useState("");
    const [allowReview, setReviewAllowed] = useState(false)

    const authEndpoint = new AuthEndpoint();
    const reviewEndpoint = new ReviewEnpoint();
    const navigate = useNavigate();


    useEffect(() => {
        const fetchUser = async () => {
            try {
                const allowedRoles = ["owner", "management"];
                const userEndpoint = new UserEndpoint();
                const response = await userEndpoint.getUser();

                if (!response?.id) {
                    setReviewAllowed(false);
                    return;
                }

                const relation = detailProperti?.relation || [];

                const isAllowed = relation.some(
                    (prp) =>
                        prp.user_id === response.id &&
                        allowedRoles.includes(prp.relation_type)
                );

                setReviewAllowed(isAllowed);
            } catch (error) {
                setReviewAllowed(false);
                console.error("Failed to fetch user data", error);
            }
        };

        if (detailProperti?.relation) {
            fetchUser();
        }
    }, [detailProperti?.relation]);



    if (!detailProperti) return <p>Loading...</p>;

    const property = detailProperti.property || {};

    const handleRentClick = async () => {
        try {
            await authEndpoint.verifySession();
            const targetUrl = `/rent-property/${detailProperti?.property?.property_type}/${detailProperti.id}`;
            console.log("Navigating to:", targetUrl);
            navigate(targetUrl);
        } catch (err) {
            setShowLoginModal(true);
            console.error("Navigation failed:", err);
        }
    };


    const propertyPhoto = getImageUrls(detailProperti.property?.photo);


    const handleReplyReview = (review) => {
        if (replyingTo === review.id) {
            // Cancel reply
            setReplyingTo(null);
            setReplyText("");
        } else {
            // Start replying to this review
            setReplyingTo(review.id);
            setReplyText("");
        }
    };

    const handleSubmitReply = async (reviewId) => {
        if (!replyText.trim()) {
            message.error("Silakan isi balasan komentar.");
            return;
        }

        try {
            await reviewEndpoint.replyReview(reviewId, {
                reply_comment: replyText
            });
            message.success("Balasan berhasil ditambahkan!");
            setReplyingTo(null);
            setReplyText("");
            // Refresh page untuk melihat balasan baru
            window.location.reload();
        } catch (err) {
            console.error(err);
            message.error("Gagal menambahkan balasan");
        }
    };  



    return (
        <div className="ltn__shop-details-area pb-10">
            <div className="container">
                <div className="row">
                    {/* Kiri */}
                    <div className="col-lg-8 col-md-12">
                        <div className="ltn__shop-details-inner ltn__page-details-inner mb-60">
                            <div className="ltn__blog-meta">
                                <ul>
                                    <li className="ltn__blog-category">
                                        <span className="bg-orange">For Rent</span>
                                    </li>
                                    <li>

                                        <span style={{ cursor: 'default' }}>
                                            <i className="far fa-comments" /> ({detailProperti?.reviews.total_review} Ulasan)
                                        </span>
                                    </li>
                                </ul>

                            </div>

                            <h1>{property.name}</h1>
                            <label>
                                <span className="ltn__secondary-color">
                                    <i className="flaticon-pin" />
                                </span>{" "}
                                {property.full_address}, {property.city}
                            </label>

                            <h4 className="title-2">Keterangan</h4>
                            <p>
                                Tower: {detailProperti.tower_name}, Unit:{" "}
                                {detailProperti.unit_number}, Lantai: {detailProperti.floor_number}.
                                <br />
                                {detailProperti.bedrooms} kamar tidur, {detailProperti.bathrooms}{" "}
                                kamar mandi.
                                <br />
                                Harga sewa: {formatRupiah(property.rent_price)} / bulan, IPL:{" "}
                                {formatRupiah(detailProperti.ipl ? detailProperti.ipl : 0)}
                                <br />
                                Fasilitas Umum: {property?.general_facilities}
                                <br />
                                Fasilitas Khusus: {property?.private_facilities}
                            </p>

                            {/* Tombol Sewa */}


                            <h4 className="title-2">Foto Properti</h4>
                            <div className="ltn__property-details-gallery mb-30">
                                <div className="row">
                                    {propertyPhoto.map((url, i) => (
                                        <div className="col-md-6" key={i}>
                                            <a href={url} data-rel="lightcase:myCollection">
                                                <img
                                                    className="mb-30"
                                                    src={url}
                                                    alt={property.name}
                                                    style={{ width: "100%", objectFit: "contain", borderRadius: 8 }}

                                                />
                                            </a>
                                        </div>
                                    ))}
                                </div>
                            </div>

                            {/* Rating & review */}
                            <ReviewRating detailProperti={detailProperti} allowReview={allowReview} handleReplyReview={handleReplyReview} handleSubmitReply={handleSubmitReply} replyingTo={replyingTo} replyText={replyText} setReplyText={setReplyText} />

                        </div>
                    </div>

                    <PropertyDetailInfo property_type={property.property_type} property={property} detailData={detailProperti} handleRentClick={handleRentClick} />

                </div>
            </div>

            {/* Modal login */}
            {showLoginModal && (
                <>
                    <div className="modal-backdrop-custom"></div>
                    <div className="modal-custom" role="dialog">
                        <div className="modal-custom-header">
                            <h5>Login Required</h5>
                            <button
                                className="modal-custom-close"
                                onClick={() => setShowLoginModal(false)}
                            >
                                ×
                            </button>
                        </div>
                        <div className="modal-custom-body">
                            <p>Silakan login terlebih dahulu untuk melakukan penyewaan.</p>
                            <a href="/login">Login</a>
                        </div>
                    </div>
                </>
            )}
        </div>
    );
};

export default ShopDetails;
